import React from "react";
import { saveTermsData } from "../../../service/employerapi";
import { toast } from "react-toastify";

const TermsModal = ({ userId, onAccept }) => {
  const handleReadMore = () => {
    window.open("https://hourlee.in/terms-and-condition", "_blank");
  };

  const handleAccept = async () => {
    console.log("Accept clicked");
    try {
      await saveTermsData({
        termCondition: true,
      });

      toast.success("Terms & Conditions accepted");
      onAccept(); // close modal in parent
    } catch (error) {
      console.error(error);
      toast.error("Failed to accept terms");
    }
  };

  return (
    <div className="terms-backdrop">
      <div className="terms-modal">
        <h4>Terms & Conditions</h4>

        <div className="terms-content">
          <p>
            <strong>Last Updated: </strong>&nbsp;07 January 2026
          </p>
          <h3>
            <strong>AGREEMENT TO TERMS</strong>
          </h3>
          <p>
            These Terms and Conditions constitute a legally binding agreement
            made between you, whether personally or on behalf of an entity
            (&ldquo;you&rdquo;) and <strong>Hourlee</strong> (&ldquo;we,&rdquo;
            &ldquo;us,&rdquo; or &ldquo;our&rdquo;), concerning your access to
            and use of the{" "}
            <a href="https://hourlee.in/">
              <strong>https://hourlee.in/</strong>
            </a>{" "}
            website as well as any other media form, media channel, mobile
            website or mobile application related, linked, or otherwise
            connected thereto (collectively, the &ldquo;Site&rdquo;). You may
            also refer to our <strong>User Service Agreement </strong>and{" "}
            <strong>Payment and Refund Policy</strong> for additional terms
            governing your use of the services.
          </p>
          <p>
            Hourlee is a digital employment platform that enables individuals to
            explore, discover, apply for, and engage with job opportunities,
            employers, recruitment services, and career-related content.
          </p>
          <p>
            You agree that by accessing the Site, you have read, understood, and
            agree to be bound by all of these Terms and Conditions.
          </p>
          <p>
            IF YOU DO NOT AGREE WITH ALL OF THESE TERMS AND CONDITIONS, THEN YOU
            ARE EXPRESSLY PROHIBITED FROM USING THE SITE, AND YOU MUST
            DISCONTINUE USE IMMEDIATELY.
          </p>
          <p>
            Supplemental terms and conditions or documents that may be posted on
            the Site from time to time are hereby expressly incorporated herein
            by reference. We reserve the right, in our sole discretion, to make
            changes or modifications to these Terms and Conditions at any time
            and for any reason.
          </p>
          <p>
            We will alert you about any changes by updating the &ldquo;Last
            updated&rdquo; date of these Terms and Conditions, and you waive any
            right to receive specific notice of each such change.
          </p>
          <p>
            It is your responsibility to periodically review these Terms and
            Conditions to stay informed of updates. You will be subject to, and
            will be deemed to have been made aware of and to have accepted, the
            changes in any revised Terms and Conditions by your continued use of
            the Site after the date such revised Terms and Conditions are
            posted.
          </p>
          <p>
            The information provided on the Site is not intended for
            distribution to or use by any person or entity in any jurisdiction
            or country where such distribution or use would be contrary to law
            or regulation or which would subject us to any registration
            requirement within such jurisdiction or country.
          </p>
        </div>

        {/* Buttons */}
        <div className="d-flex gap-2 mt-3">
          <button
            type="button"
            className="normalbtn"
            style={{
              backgroundColor: "#270b79",
              border: "4px solid #270b79",
            }}
            onClick={handleReadMore}
          >
            Read More
          </button>

          <button type="button" className="normalbtn" onClick={handleAccept}>
            Accept & Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;